import { Component, Input, OnInit } from '@angular/core';
import { Chart, registerables } from 'chart.js';
@Component({
  selector: 'chart-line',
  standalone: true,
  imports: [],
  templateUrl: './line.component.html',
  styleUrls: ['./line.component.scss'], 
})
export class LineComponent implements OnInit {
  chart: any;
  @Input() labels: string[] = [];
  @Input() corrects: number[] = [];
  @Input() wrongs: number[] = [];

  ngOnInit(): void { 
    Chart.register(...registerables);
    this.chart = new Chart('canvasLine', {
      type: 'line',
      data: { 
        labels: this.labels, 
        datasets: [
          {
            label: 'Acertos',
            data: this.corrects,
            fill: false,
            borderColor: '#28a745', // Verde para a linha
            backgroundColor: '#FFFFFF', // Branco para os pontos
            pointBorderColor: '#28a745', // Borda dos pontos verde
            pointBackgroundColor: '#FFFFFF', // Fundo dos pontos branco
            tension: 0.3, // Suavizar a curva
          },
          {
            label: 'Erros',
            data: this.wrongs,
            fill: false,
            borderColor: '#dc3545', // Vermelho para a linha
            backgroundColor: '#FFFFFF', // Branco para os pontos
            pointBorderColor: '#dc3545', // Borda dos pontos vermelha
            pointBackgroundColor: '#FFFFFF', // Fundo dos pontos branco
            tension: 0.3, // Suavizar a curva
          },
        ],
      },
      options: {
        responsive: true, 
        plugins: {
          legend: {
            display: true,
            position: 'top',
          },
        },
        scales: {
          x: {
            beginAtZero: true,
            grid: {
              color: '#EDEDED', // Grade de cor clara
            },
          },
          y: {
            beginAtZero: true,
            grid: {
              color: '#EDEDED', // Grade de cor clara
            },
          },
        },
      },
    });
  }
}
